module.exports = __webpack_public_path__ + "img/linkredit LOGO.a4a49f53.png";